module.exports = __webpack_public_path__ + "media/images/register_bg-a73c2916c19c913a5d8b2501ccb3c908.png";